import React from "react";

export default function RequiredAstrick({ required }) {
  return <>{required ? <span style={{ color: 'red' }}>*</span> : null}</>;
}
